<template>
  <v-main>
    <audio id="reg-sound" ref="regSound"><source src="./../../../assets/snd/effect1.wav" type="audio/wav"></audio>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n2">{{$t("Registrations")}}</h1>
          <v-flex xs12 class="mb-4">
            <v-layout row wrap>
              <v-checkbox class="mt-5 ml-2 mr-2" :label="$t('Newest registrations first')" v-model="newestRegistrationsFirst" @change="newestRegistrationsFirstChanged" :color="'primary'"></v-checkbox>
              <v-checkbox v-if="!playSound" class="mt-5 ml-2 mr-2" v-model="playSound" @change="soundOnce()" :off-icon="'notifications_active'" ></v-checkbox>
              <v-flex grow></v-flex>
              <v-flex shrink>
                <v-select class="ml-2" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-progress-linear class="mt-n4" v-if="loading" :indeterminate="true"></v-progress-linear>
          <div v-else>

            <div v-if="registrations != null && registrations.length == 0" style="text-align: center">{{$t("Nothing to inspect")}}</div>
            <div v-else v-for="registration in registrations" :key="registration.id">
              <v-card v-if="registration.hasOwnProperty('Header')" raised class="mb-8 mt-n4">
                <div v-for="header in registration.Header" :key="header.id">
                    <v-flex xs12>
                    <v-layout v-if="isImageHeader(registration, header)" row wrap class="textsize-svs" :style="getHeaderStyle(header)" style="padding: 0px 0px 0px 14px">
                        <v-flex d-flex xs5>{{getCameraName(registration, header)}}</v-flex><v-flex d-flex xs7>
                          <img :src="getImageValue(registration, header)" style="width:100%;max-width: 400px;height:auto;"></v-flex>
                    </v-layout>
                    <v-layout v-else row wrap class="textsize-svs" :style="getHeaderStyle(header)" style="padding: 0px 0px 0px 14px">
                        <v-flex d-flex xs5>{{$t(header.Field)}}</v-flex><v-flex d-flex xs7>{{getHeaderValue(registration, header)}}</v-flex>
                    </v-layout>
                  </v-flex>
                </div>
                <v-divider></v-divider>
                <v-card-actions style="padding: 0px 0px 0px 0px">
                  <v-flex xs12 text-right>
                    <!-- block vehicle button-->
                    <v-btn class="mr-1 mb-1" v-if=!showDisableBtn(registration) @click.prevent="blockVehicle(registration)" color="error">
                      {{$t("Block Vehicle")}}
                    </v-btn>
                    <!-- Skip inspection button -->
                    <v-btn class="mr-1 mb-1" v-if="!isInProgress(registration.InspectionStartDate) && enableSkip" @click.prevent="confirmSkipInspection(registration.Id)" color="warning">
                      {{$t("Skip Inspection")}}
                    </v-btn>
                    <!-- Do inspection button when in progress -->
                    <v-btn class="mr-1 mb-1" v-if="isInProgress(registration.InspectionStartDate)" type="primary" color="#aaa">
                      {{$t("In Progress")}}
                    </v-btn>
                    <!-- Do inspection button when not in progress -->
                    <v-btn class="mr-1 mb-1" v-if="!isInProgress(registration.InspectionStartDate)" :to="{name: 'inspection', params: {id: registration.Id}}" type="primary" color="success">
                      {{$t("Do Inspection")}}
                    </v-btn>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </div>

          </div>
        </v-flex>

        <v-dialog
          v-model="skipInspectionConfirmDialog"
          max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t("Skip Inspection")}}</v-card-title>

            <v-card-text>
              {{$t("SkipInspectionConfirmDescription")}}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="success"

                @click="skipInspectionConfirmDialog = false; doSkipInspection();">
                {{$t("Yes")}}
              </v-btn>

              <v-btn
                color="primary"

                @click="skipInspectionConfirmDialog = false">
                {{$t("No")}}
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as DateUtil from '@/core/date'
import * as Security from '@/core/security'
import * as DeliveryInspection from '@/modules/delivery-inspection/delivery-inspection'
import * as LocalStorage from '@/core/local-storage'
import * as Archive from '@/core/archive'
import _ from 'lodash' // clone

export default {
  mixins: [filters],
  name: 'registrations',
  data () {
    return {
      newestRegistrationsFirst: true,
      loading: true,
      registrations: null,
      badInspection: false,
      loadRegistrationsIntervalId: null,
      skipInspectionConfirmDialog: false,
      skippingInspectionId: '00000000-0000-0000-0000-000000000000',
      facilityNo: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      playSound: false,
      showDisableVehicleBtn: false
    }
  },
  methods: {
    soundOnce () {
      this.sound()
      this.$root.$message.showSuccess(this.$t('Sound on'))
    },
    sound () {
      // Play a sound also on iPad needs user one invoke to work, by clicking on the bell icon
      // double call is a workaround due to iPad fail when play once - sounds like one sound
      this.$refs.regSound.currentTime = 0
      this.$refs.regSound.play()
      this.$refs.regSound.currentTime = 0
      this.$refs.regSound.play()
    },
    isImageHeader (item, header) {
      let result = false
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        if (item.WeightRegistration) {
          const pre = header.Field.substring(0, 13)
          const post = header.Field.substring(11, 50)
          if (pre === 'ImageCapture_' && post) {
            try {
              const jsonStr = item.WeightRegistration.ImageData
              // eslint-disable-next-line no-unused-expressions
              JSON.parse(jsonStr)[post] // We assume that customdata is stored as json. E.g. {Cam1: '<base64 image>'}. Lets try to parse it.
              result = true
            } catch (error) {
              console.log('Warning: ', error.message)
              result = false
            }
          }
        }
      }
      return result
    },
    getCameraName (item, header) {
      let result = 'Cam'
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        if (item.WeightRegistration) {
          const pre = header.Field.substring(0, 13)
          const post = header.Field.substring(13, 50)
          if (pre === 'ImageCapture_' && post) {
            try {
              result = post
            } catch (error) {
              console.log('Warning: ', error.message)
            }
          }
        }
      }
      return result
    },
    getImageValue (item, header) {
      let result = 'iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAELUExURSM3XTsxU2MqRGQqQ1csSCU2XDkxVGMqQ2coQkcuTzUyV7wbIs8YG88ZG8sYHFEtTEIwUbobIs8YGp8gLyo1WnwlO5wgLyY2XDgyVbIcJqoeKTE0WDkyVcEaIcsZHEkuTzIzV6geKrMdJjsyVIMlOZogMJ4fLrsaIkYvUDsyVcQaH9AYGs4YG8MaH1EuTJ4gLm4oQCQ3XWkoQ5QiMl8qRscZHs0YG5ghL8UaHscZHUQwUFMsS8EaH5YhMi41WYwjNNAZG4wiNEcuUL4aIqAfLUIwUsgZH8MZHj8xUzoyVLkbIqweKTI0V5QhMc4YGoUjN2AqRXIoPmopQTAzWDYzVXMoPnIoP2kpQio0WgVuYekAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACsSURBVChTjY1FFgJBDEQDg5NGggzu7oO7uzvc/yTQMBt21Cb1U3kV+EcKpSCo1NxptDr9exiMyEzmt7FYyWbngQORnCK43OTxcgafHykQDIUxEv0wQAwR4wlKpmSGdCbLcixfkBFALBIhlSQZQSoHGDGsfF5zrtbqjSZhqy0vOl3W6w9wSKPvyXiC0z7M5oSLJefVmm22Eog7pP2B1x5P5wsPrqfb/fHk7kcAL9jCEsf2hIaRAAAAAElFTkSuQmCC'
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        if (item.WeightRegistration) {
          const pre2 = header.Field.substring(0, 13)
          const post = header.Field.substring(13, 50)
          // Use prefixed 'CustomData_' in Field to support custom data (e.g. CustomData_FuelType or CustomData_TreatmentProcesses).
          if (pre2 === 'ImageCapture_' && post) {
            try {
              const jsonStr = item.WeightRegistration.ImageData
              result = 'data:image/png;base64,' + JSON.parse(jsonStr)[post] // We assume that customdata is stored as json. E.g. {Cam1: '<base64 image>'}
            } catch (error) {
              result = error.message
            }
          }
        }
      }
      return result
    },
    getHeaderValue (item, header) {
      let result = ''
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        if (item.WeightRegistration) {
          const pre = header.Field.substring(0, 11)
          const post = header.Field.substring(11, 50)
          // Use prefixed 'CustomData_' in Field to support custom data (e.g. CustomData_FuelType or CustomData_TreatmentProcesses).
          if (pre === 'CustomData_' && post) {
            try {
              const jsonStr = item.WeightRegistration.CustomData
              result = JSON.parse(jsonStr)[post] // We assume that customdata is stored as json. E.g. {FuelType: 'Bioolje'}
            } catch (error) {
              result = error.message
            }
          } else {
            result = item.WeightRegistration[header.Field]
          }
        }
      } else {
        if (header.Source === 'DeliveryInspection') {
          result = item[header.Field]
        }
      }
      if (header.AsDate) result = DateUtil.getSmartDate(result)
      return result
    },
    getHeaderStyle (header) {
      let result = ''
      if (Object.prototype.hasOwnProperty.call(header, 'Style')) {
        result = header.Style
      }
      return result
    },
    isInProgress (inspectionStartDate) {
      if (inspectionStartDate) { return true }

      return false
    },
    /* isBlocked (registration) { */
    showDisableBtn (registration) {
      // if (registration.IsBlocked) { return true }
      if (this.showDisableVehicleBtn) {
        return false
      }

      return true
    },
    async confirmSkipInspection (registrationId) {
      this.skipInspectionConfirmDialog = true
      this.skippingInspectionId = registrationId
    },
    async blockVehicle (deliveryInsp) {
      this.submitting = true
      const res = await DeliveryInspection.blockVehicle({
        id: deliveryInsp.Id,
        vehicleNo: deliveryInsp.WeightRegistration.VehicleNo,
        facility: this.facilityNo
      })
      /* if (!res.failed) {
        this.registrations = this.registrations.filter(item => item.Id !== deliveryInsp.Id)
        // this.$router.push({ name: 'registrations' })
      } */

      if (res.failed) {
        this.$root.$message.showError(this.$t('Block Vehicle Failed') + ': ' + res.message)
      } else {
        this.$root.$message.showSuccess(this.$t('Vehicle') + ': ' + deliveryInsp.WeightRegistration.VehicleNo + ' ' + this.$t('is now inactive'))
      }

      this.submitting = false
    },
    async doSkipInspection () {
      this.submitting = true

      const res = await DeliveryInspection.skipInspection({
        id: this.skippingInspectionId
      })
      if (!res.failed) {
        this.registrations = this.registrations.filter(item => item.Id !== this.skippingInspectionId)
        // this.$router.push({ name: 'registrations' })
      }

      this.submitting = false
    },

    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }
      if (this.facilityNo != null) {
        LocalStorage.save('facilityNo', this.facilityNo)
      }
      this.registrations = null
      const res = await DeliveryInspection.loadRegistrations(this.facilityNo, this.newestRegistrationsFirst)
      if (!res.failed) this.registrations = res.data
    },

    async newestRegistrationsFirstChanged () {
      this.registrations = null
      const res = await DeliveryInspection.loadRegistrations(this.facilityNo, this.newestRegistrationsFirst)
      if (!res.failed) this.registrations = res.data
      LocalStorage.save('newestRegistrationsFirst', this.newestRegistrationsFirst)
    }

  },
  computed: {
  },
  beforeDestroy () {
    // Stop update of registration list
    clearInterval(this.loadRegistrationsIntervalId)
  },
  async mounted () {
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    // Update registration list every 5 seconds
    this.loadRegistrationsIntervalId = setInterval(async () => {
      const res = await DeliveryInspection.loadRegistrations(this.facilityNo, this.newestRegistrationsFirst)
      // console.log('cp1 x1 ', res.failed)
      if (!res.failed) {
        let currentRegs = ''
        let newRegs = ''
        for (const reg of this.registrations) {
          currentRegs = currentRegs + reg.Id
        }
        for (const reg of res.data) {
          newRegs = newRegs + reg.Id
        }

        // If more regs or if same amount, but not same regs
        if (newRegs.length > currentRegs.length || (currentRegs.length === newRegs.length && currentRegs !== newRegs)) {
          // Play a sound also on iPad
          this.sound()
        }

        this.registrations = res.data
      }
    }, 5000)

    if (Security.user.corporationDetails) {
      this.enableSkip = !(Security.user.corporationDetails.find(d => d.Name === 'DeliveryInspection_Hide_Skip')?.Data1 === 'true')
      this.showDisableVehicleBtn = (Security.user.corporationDetails.find(d => d.Name === 'DeliveryInspection_Show_Disable')?.Data1 === 'true')
    }

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    // TODO: Clean this up
    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }

    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    this.newestRegistrationsFirst = LocalStorage.load('newestRegistrationsFirst')

    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) this.facilityNo = storedFacilityNo
    else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }
    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }
    const res = await DeliveryInspection.loadRegistrations(this.facilityNo, this.newestRegistrationsFirst)
    this.loading = false
    if (!res.failed) {
      this.registrations = res.data
    }

    // Always play sound on page load, if any registrations exists
    if (this.registrations.length > 0) this.sound()
  }
}
</script>

<style>
</style>
